<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedication"></a><a id="page_v"><span class="txit">To Caroline, who went with me to the source of the Potomac and helped me find the way back home</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9cd30f42